<template>
  <div :class="`content ${contentClass}`">
    <div :class="`list ${listClass}`">
      <div
        :class="`list-item ${itemClass}`"
        v-for="(item, index) in effectList"
        :key="item[keyName]"
        @click="toggleSingle(index)"
      >
        <base-icon
          v-if="item.isChoosed"
          icon="iconbianzu4"
          fontSize="20"
          className="margin-right-6"
        ></base-icon>
        <base-icon
          className="margin-right-6"
          v-else
          icon="iconbianzu4beifen"
          fontSize="20"
        ></base-icon>
        <slot name="list-item" :item="item"></slot>
      </div>
    </div>
    <div class="all-choose">
      <div class="all-choose-button" @click="toggleAll">
        <base-icon
          v-if="allChoosedStatus === 'allChoosed'"
          icon="iconbianzu22"
          fontSize="20"
        ></base-icon>
        <base-icon
          v-else-if="allChoosedStatus === 'partChoosed'"
          icon="iconbianzu3"
          fontSize="20"
        ></base-icon>
        <base-icon v-else icon="iconbianzu4beifen" fontSize="20"></base-icon>
      </div>
      <slot name="all-choose-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      effectList: this.list.map((v) => {
        if (v.isChoosed) {
          return v;
        } else {
          return {
            ...v,
            isChoosed: false,
          };
        }
      }),
      show: false,
    };
  },

  watch: {
    list(value, oldValue) {
      this.effectList =
        value.map((v) => {
          if (v.isChoosed) {
            return v;
          } else {
            return {
              ...v,
              isChoosed: false,
            };
          }
        });
    },
    effectList(value, oldValue) {
      this.choosedList = value
        .filter((v) => v.isChoosed)
        .map(({ isChoosed, ...rest }) => ({ ...rest }));
    },
  },

  props: {
    keyName: { type: String, default: "id" },
    value: { type: Array, default: [] }, // v-model绑定值，已选择的列表项 {name: string, id: number, is}
    list: { type: Array, default: [] }, // 原数据列表
    listClass: { type: String, default: "list-default" },
    itemClass: { type: String, default: "item-default" },
    contentClass: { type: String, default: "content-default" },
  },
  computed: {
    choosedList: {
      get() {
        return value;
      },

      set(value) {
        console.log("111");
        this.$emit("input", value);
      },
    },
    allChoosedStatus() {
      if (
        this.effectList.filter((v) => v.isChoosed).length ===
        this.effectList.length
      ) {
        return "allChoosed"; // 全选
      } else if (this.effectList.filter((v) => v.isChoosed).length > 0) {
        return "partChoosed"; // 半选
      } else {
        return "nullChoosed"; // 全部未选
      }
    },
  },

  methods: {
    toggleSingle(index) {
      this.effectList[index].isChoosed = !this.effectList[index].isChoosed;
      this.$set(this.effectList, index, this.effectList[index]);
    },
    toggleAll() {
      if (this.effectList.some((v) => !v.isChoosed)) {
        this.effectList = this.effectList.map((v) => {
          return {
            ...v,
            isChoosed: true,
          };
        });
      } else {
        this.effectList = this.effectList.map((v) => {
          return {
            ...v,
            isChoosed: false,
          };
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.list {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex: 1;
}
.list-item {
  cursor: pointer;
}
.all-choose {
  flex: none;
  display: flex;
  padding: 10px;
  align-items: center;
  height: 40px;
}
.all-choose-button {
  cursor: pointer;
  margin-right: 6px;
}
.content-default {
  background: #ffffff;
  border: 1px solid rgba(235, 235, 235, 1);
}
.item-default {
  display: flex;
  padding: 10px;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid rgba(235, 235, 235, 1);
}
</style>
